"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));

var NotificationsSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _store = _interopRequireDefault(require("../store/store"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var BulkNotificationUpdateService =
/*#__PURE__*/
function () {
  function BulkNotificationUpdateService() {
    (0, _classCallCheck2.default)(this, BulkNotificationUpdateService);
  }

  (0, _createClass2.default)(BulkNotificationUpdateService, [{
    key: "markAllAsRead",
    value: function () {
      var _markAllAsRead = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var pulseApiHelper, activeIMSOrg, url, ansApiHeaders, params, response;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pulseApiHelper = new _PulseApiHelper.default();
                activeIMSOrg = NotificationsSelectors.getActiveIMSOrg(_store.default.getState());
                url = new URL("".concat(pulseApiHelper.getHostUrl(), "/ans/v2/notifications/state/all"));
                ansApiHeaders = pulseApiHelper.getDefaultHeaders();
                params = {};
                params['ims_org'] = activeIMSOrg;
                _context.next = 8;
                return fetch(url, {
                  method: 'PUT',
                  headers: ansApiHeaders,
                  body: JSON.stringify({
                    'state': 'READ',
                    'ims-org': activeIMSOrg
                  })
                });

              case 8:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 12;
                  break;
                }

                console.log("BulkNotificationUpdateService failed, HTTP status ".concat(response.status));
                return _context.abrupt("return", false);

              case 12:
                return _context.abrupt("return", true);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function markAllAsRead() {
        return _markAllAsRead.apply(this, arguments);
      }

      return markAllAsRead;
    }()
  }]);
  return BulkNotificationUpdateService;
}();

var _default = new BulkNotificationUpdateService();

exports.default = _default;